module.exports = __webpack_public_path__ + "static/media/AI_13.29359d43.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AI_13.png
// module id = 128
// module chunks = 0